import { DrawerProps } from 'components/Drawer/Root'
import { Drawer } from 'components/Drawer'
import { BrandKitMenu } from 'screens/BrandKit/BrandKitMenu/BrandKitMenu'
import { BrandKit } from 'types'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props extends DrawerProps {
  brandKit: BrandKit
}

export const BrandKitMenuDrawer = ({ brandKit, ...props }: Props) => {
  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>More Options</Heading>
              </Drawer.Title>
              <Drawer.Close variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <BrandKitMenu brandKit={brandKit} menuType="tray" onRename={() => props.onClose?.()} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
